import { Textbox } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { TextFieldProps, TextFieldValues } from './types';
import styles from '../styles';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const TextField = <Value extends TextFieldValues>({
  id,
  name,
  config,
  ...props
}: TextFieldProps<Value>) => {
  const classes = useStyles();
  const { input, meta } = useField<Value, HTMLInputElement, string>(name, config);

  return (
    <div className={classes.fieldContainer}>
      <Textbox
        {...input}
        {...props}
        errorMessage={getErrorMessage(meta)}
        id={id ?? name}
        type={input.type ?? 'text'}
      />
    </div>
  );
};

export default TextField;
